import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-pos-tfg-rewards-view-voucher',
  templateUrl: './pos-tfg-rewards-view-voucher.component.html',
  styleUrls: ['./pos-tfg-rewards-view-voucher.component.scss'],
})
export class PosTfgRewardsViewVoucherComponent implements OnInit {
  voucher: any;

  constructor(
    private baseService: BaseService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PosTfgRewardsViewVoucherComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.baseService
      .executeCommand<any>(
        'portal_tfg_rewards_get_sales_order_voucher_details',
        { salesOrderHeaderId: this.data.salesOrderHeaderId, salesOrderNumber: this.data.salesOrderNumber }
      )
      .subscribe((detailResponse) => {
        if (detailResponse.responseCode === 0) {
          this.voucher = detailResponse.data;
        }
      });
  }

  removeTfgVoucher() {
    const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
      width: '450px',
      data: {
        title: 'Remove TFG Rewards Voucher?',
        text: `Please confirm you want to delete the TFG Rewards voucher linked to this order.`,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showConfirmButton: true,
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmButtonClicked === true) {
        this.baseService
          .executeCommand<any>(
            'portal_sales_order_header_remove_tfg_rewards_voucher',
            { salesOrderHeaderId: this.data.salesOrderHeaderId }
          )
          .subscribe((response) => {
            if (response.responseCode === 0) {
              this.dialogRef.close(null);
            }
          });
      }
    });
  }
}
